import styled from 'styled-components'

import {
  primary,
  primaryTransparency,
  textPrimary,
  transparency,
  greySecondary,
} from 'styles/Colors'

export const Divider = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${greySecondary};
`

export const Container = styled(({ small, mini, ...props }) => <div {...props} />)`
  position: relative;
  height: ${({ small, mini }) => (small || mini ? 'auto' : '48.8vh')};
  width: 100%;
  padding-top: ${({ mini }) => mini && '0.625rem'};
  color: #EB7C0C;
  font-family: coresanscr55;
`
export const DayLine = styled(({ small, mini, ...props }) => <div {...props} />)`
  display: grid;
  grid-template-columns: repeat(7, ${({ small, mini }) => (small ? '25px' : mini ? '20px' : '1fr')});
  text-align: center;
  grid-column-gap: ${({ small, mini }) => (small ? '0' : mini ? '0' : '1rem')};
  justify-content: ${({ mini }) => mini && 'space-between'};
  color: ${({ mini }) => mini && primary};
  background-color: ${({ mini }) => mini && primaryTransparency};
  padding: ${({ mini }) => mini && '2.5px 5px'};
  border-radius: ${({ mini }) => mini && '50px'};
`
export const DayTitle = styled(({ small, mini, ...props }) => <div {...props} />)`
  font-size: ${({ small, mini }) => (small ? '0.9375rem' : mini ? '0.625rem' : '18px')};
`
export const NumbersGrid = styled(({ small, mini, ...props }) => <div {...props} />)`
  display: grid;
  grid-template-columns: repeat(7, ${({ small, mini }) => (small ? '25px' : mini ? '20px' : '1fr')});
  grid-template-rows: repeat(6, ${({ small, mini }) => (small ? '25px' : mini ? '19px' : '3rem')});
  justify-content: space-between;
  text-align: center;
  grid-row-gap: ${({ small, mini }) => (small ? '0.6875rem' : mini ? '0.6rem' : '1rem')};
  grid-column-gap: ${({ small, mini }) => (small ? '0' : mini ? '0' : '1rem')};
  max-width: 100%;
  padding: ${({ mini }) => mini && '0 5px'};
`
export const Number = styled(({ disabled, color, small, mini, isToday, isOtherMonth, ...props }) => <div {...props} />)`
  font-size: ${({ mini }) => mini && '10px'};
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ disabled, color, isOtherMonth }) => {
    if (disabled) return textPrimary + transparency[50]
    if (isOtherMonth && color === 'transparent') return textPrimary + transparency[40] // Dimmed for other month
    return color !== 'transparent' ? 'white' : textPrimary
  }};
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  transition: color 300ms ease-in;
  opacity: ${({ disabled }) => (disabled ? 0.4 : 1)};
  &::before {
    content: '';
    position: absolute;
    width: ${({ small, mini }) => {
      if (small || mini) return '22px'
      return '39px' // 25% smaller than 52px
    }};
    height: ${({ small, mini }) => {
      if (small || mini) return '22px'
      return '39px' // 25% smaller than 52px
    }};
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border-radius: 50%;
    background-color: ${({ color }) => color};
    transition: background-color 300ms ease-in;
    z-index: -1;
  }
  &::after {
    content: 'none';
    display: none;
  }
`
export const Event = styled(({ color, isToday, mini, ...props }) => <div {...props} />)`
  position: absolute;
  top: ${({ isToday, mini }) => {
    if (mini && isToday) return '50%' // Center on date number for mini today
    return isToday ? '-6px' : '-10px' // Closer to the circle for today
  }};
  left: 50%;
  transform: ${({ isToday, mini }) => {
    if (mini && isToday) return 'translate(-50%, -50%)' // Center both horizontally and vertically
    return 'translate(-50%, 0)'
  }};
  width: ${({ isToday, mini }) => {
    if (mini && isToday) return '17px' // Circle outline for mini today (40% larger)
    return isToday ? '4.5px' : '3px' // 50% larger for today in regular mode
  }};
  height: ${({ isToday, mini }) => {
    if (mini && isToday) return '17px' // Circle outline for mini today (40% larger)
    return isToday ? '4.5px' : '3px' // 50% larger for today in regular mode
  }};
  border-radius: 50px;
  background-color: ${({ color, isToday, mini }) => {
    if (mini && isToday) return 'transparent' // Transparent background for outline
    return color
  }};
  border: ${({ isToday, mini, color }) => {
    if (mini && isToday) return `1px solid ${color}` // Circle outline for mini today
    return 'none'
  }};
  opacity: ${({ isToday }) => (isToday ? '0.8' : '1')}; // 80% opacity for today's indicator
  z-index: ${({ isToday, mini }) => (mini && isToday ? '1' : 'auto')}; // Ensure circle appears above content
`
